import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import ContactForm from '../components/contact/ContactForm';

const ContactPage = () => {
  return (
    <div className="pt-24">
      <div className="bg-primary text-white py-16">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Contactez-nous</h1>
          <p className="text-xl max-w-2xl">
            Des questions? Besoin d'informations supplémentaires? Notre équipe est prête à vous aider.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Contact Form */}
            <div className="lg:col-span-2">
              <ContactForm />
            </div>

            {/* Contact Info */}
            <div>
              <div className="bg-white p-8 rounded-lg shadow-md mb-8">
                <h3 className="text-2xl font-bold mb-6">Informations de contact</h3>
                
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="bg-primary/10 p-3 rounded-full">
                      <FaMapMarkerAlt className="text-primary text-xl" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Adresse</h4>
                      <p className="text-gray-600">
                      5163 Boulevard Métropolitain E<br />
                      Saint-Leonard, Quebec H1R 1Z7<br />
                        Canada
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="bg-primary/10 p-3 rounded-full">
                      <FaPhone className="text-primary text-xl" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Téléphone</h4>
                      <p className="text-gray-600">
                        <a href="tel:+15145735871" className="hover:text-primary transition-colors">
                          +1 (514) 473-5871 
                        </a><br/>
                        <a href="tel:+15142986254" className="hover:text-primary transition-colors">
                          +1 (514) 298-6254
                        </a>
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="bg-primary/10 p-3 rounded-full">
                      <FaEnvelope className="text-primary text-xl" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Email</h4>
                      <p className="text-gray-600">
                        <a href="mailto:info@dzfood.ca" className="hover:text-primary transition-colors">
                          info@dzfood.ca
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="bg-white p-8 rounded-lg shadow-md">
                <h3 className="text-2xl font-bold mb-6">Heures d'ouverture</h3>
                <ul className="space-y-3">
                  <li className="flex justify-between">
                    <span className="font-medium">Lundi - Vendredi:</span>
                    <span>8h00 - 17h00</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="font-medium">Samedi:</span>
                    <span>9h00 - 13h00</span>
                  </li>
                  <li className="flex justify-between">
                    <span className="font-medium">Dimanche:</span>
                    <span>Fermé</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <div className="h-96 bg-gray-200">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2792.4764093829654!2d-73.59668591454447!3d45.58096685107525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc91f0029c864b5%3A0xc177c476ec115e36!2sDZF%20DISTRIBUTION!5e0!3m2!1sen!2sus!4v1768500674806!5m2!1sen!2sus"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="DZF Distribution Location"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactPage; 